/**
 * Configuración global de endpoints
 * Se adjuntan a la API_BASE_SRC
 * Ej: API_BASE_SRC + '/' + endpoints.EJEMPLO
 */
export const CONSULTAR_OFERTA = "post";
export const CONFIRMAR_FORMULARIO = "openmarket/formularioAdquisicion/alta";
